import { render } from "./chatBot.vue?vue&type=template&id=21ee30b6&scoped=true"
import script from "./chatBot.vue?vue&type=script&lang=js"
export * from "./chatBot.vue?vue&type=script&lang=js"

import "./chatBot.vue?vue&type=style&index=0&id=21ee30b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ee30b6"]])

export default __exports__